module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-BlkIt.4b1edd5.woff2";